import { css, unsafeCSS } from 'lit';
export const themeLight = (targetName = ':root') => css `
  /* @Builder: skip minify */
  ${unsafeCSS(targetName)} {
    --logo-text-color: #1b314f;

    --color-background-bg-overlay: #000000;
    --color-background-bg-active: #ffffff;
    --color-background-bg-body: #f1f1f1;
    --color-background-bg-critical: #f048322e;
    --color-background-bg-critical-hover: #f048323d;
    --color-background-bg-disabled: #f5f5f5;
    --color-background-bg-info: #2f8af52e;
    --color-background-bg-info-hover: #2f8af53d;
    --color-background-bg-positive: #008a7c2e;
    --color-background-bg-positive-hover: #008a7c3d;
    --color-background-bg-primary: #ffffff;
    --color-background-bg-secondary: #f8f8f8;
    --color-background-bg-tertiary: #b6b6b6;
    --color-background-bg-warning: #ff9c082e;
    --color-background-bg-warning-hover: #ff9c083d;
    --color-border-border-primary: #1f1f1f;
    --color-border-border-secondary: #b8b8b8;
    --color-border-border-tertiary: #e0e0e0;
    --color-content-content-disabled: #b8b8b8;
    --color-content-content-primary: #1f1f1f;
    --color-content-content-primary-inv: #ffffff;
    --color-content-content-secondary: #7e7e7e;
    --color-content-content-tertiary: #a4a4a4;
    --color-core-black: #181818;
    --color-core-white: #ffffff;
    --color-core-blue-info: #2f8af5;
    --color-core-blue-info-hover: #157cf4;
    --color-core-green-positive: #008a7c;
    --color-core-green-positive-hover: #00786c;
    --color-core-orange-warning: #ff9c08;
    --color-core-orange-warning-hover: #eb8d00;
    --color-core-red-critical: #f04832;
    --color-core-red-critical-hover: #ee2f16;
  }
`;
//# sourceMappingURL=light.style.js.map